import { IFilter } from '@syncfusion/ej2-angular-grids';
import { DynamicFilterConfig } from './dynamic-entity-definition';
import { GridConstantsFactory } from '../syncfusion/grid-constants-factory';
import { SfFilterTypes } from '../../models/syncfusion-data';

export class DynamicGridFilterFactory {
  public static createColumnFilter(filterConfig?: DynamicFilterConfig): IFilter {
    const menuFilter: IFilter = { type: SfFilterTypes.Menu };

    if (!filterConfig) {
      return menuFilter;
    }

    switch (filterConfig.kind) {
      case 'boolean':
      case 'enum':
      case 'reference':
        return GridConstantsFactory.createCheckBoxFilter();
      case 'date':
        return {
          ...GridConstantsFactory.createDateFilter(),
          type: SfFilterTypes.Menu,
        };
      case 'string':
      case 'number':
      default:
        return menuFilter;
    }
  }
}
